import { REQUEST_TYPES } from '../requestTypes';
import { ENTITY_NAMES } from '../entityNames';
import { EMPTY_OBJECT } from '../../../utils/constants';
import { ENDPOINTS } from '../../../config/config';
import { DASHBOARD_API_URLS } from '../../constants';
import { type RequestHandlerFactory } from '../../types';

const requestFactory =
    (entity: string): RequestHandlerFactory =>
    params => ({
        transformResponse: (res: any) => {
            const results = res?.[entity]?.data;
            return {
                entities: {
                    [entity]: {
                        items: results,
                        itemsMeta: EMPTY_OBJECT
                    }
                }
            };
        },
        descriptors: {
            [entity]: {
                method: 'post',
                defaultEndpoint: ENDPOINTS.VF_DASHBOARD_URL,
                url: DASHBOARD_API_URLS.V2.CALLS,
                data: params
            }
        }
    });

export const callAmountStatsRequests: Record<string, RequestHandlerFactory> = {
    [REQUEST_TYPES.GET_OVERVIEW_CALL_AMOUNT]: requestFactory(ENTITY_NAMES.OVERVIEW_CALL_AMOUNT),
    [REQUEST_TYPES.GET_OVERVIEW_AGENCY_CALL_AMOUNT]: requestFactory(ENTITY_NAMES.OVERVIEW_AGENCY_CALL_AMOUNT),
    [REQUEST_TYPES.GET_OVERVIEW_AGENT_CALL_AMOUNT]: requestFactory(ENTITY_NAMES.OVERVIEW_AGENT_CALL_AMOUNT),
    [REQUEST_TYPES.GET_LOCATION_TEAMS_CALL_AMOUNT]: requestFactory(ENTITY_NAMES.OVERVIEW_LOCATIONS_TEAMS_CALL_AMOUNT),
    [REQUEST_TYPES.GET_AGENCIES_CALL_AMOUNT]: requestFactory(ENTITY_NAMES.AGENCIES_CALL_AMOUNT),
    [REQUEST_TYPES.GET_LOCATIONS_CALL_AMOUNT]: requestFactory(ENTITY_NAMES.LOCATIONS_CALL_AMOUNT),
    [REQUEST_TYPES.GET_AGENCY_LOCATIONS_CALL_AMOUNT]: requestFactory(ENTITY_NAMES.AGENCY_LOCATIONS_CALL_AMOUNT)
};
